











import Vue from 'vue';
import { mapState } from 'vuex';

export default Vue.extend({
  name: 'BaseLayout',
  middleware: ['errorRouteGuard', 'hubspot', 'hotjar', 'accountSetupGuard'],
  computed: {
    ...mapState('user', ['overrideMobileWarning'])
  }
});
